<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="min"></v-text-field>
      <v-text-field v-model="max"></v-text-field>
      <v-text-field v-model="current"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-slider
        v-model="current"
        readonly
        :thumb-size="32"
        thumb-label="always"
        :min="min"
        color="light-blue accent-4"
        track-color="light-blue accent-1"
        height="20px"
        :max="max"
      ></v-slider>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      current: 10,
      min: 0,
      max: 50
    };
  }
};
</script>

<style>
</style>